import styled from '@emotion/styled'
import {Color} from '../../Styles'

export const ContentBlock = styled.div`
  padding: 16px 20px 16px 20px;
  border-radius: 6px;
  background: ${Color.White};
  max-width: 600px;
  margin: 0 auto 16px;
`

export const BorderedContentBlock = styled.div`
  padding: 20px 16px;
  border: 1px solid ${Color.Grey100};
  max-width: 600px;
  margin: 0 auto;
`
